import { render, staticRenderFns } from "./previewInformation.vue?vue&type=template&id=2a870f51&scoped=true&"
import script from "./previewInformation.vue?vue&type=script&lang=js&"
export * from "./previewInformation.vue?vue&type=script&lang=js&"
import style0 from "./previewInformation.vue?vue&type=style&index=0&id=2a870f51&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a870f51",
  null
  
)

export default component.exports